import React, { useEffect, useState } from "react";
import { Header } from "../components";
import { useAdminContext } from "../contexts/AdminContext";
import { useMemo } from "react";
import Table from "../components/Table";
import { useStateContext } from "../contexts/ContextProvider";
import { Box, Tooltip, IconButton } from "@mui/material";
import { Send } from "@mui/icons-material";
import { useNavigate, Link } from "react-router-dom";
import Loading from "../components/Loading";
import { useFetchContext } from "../contexts/FetchContext";
import moment from "moment";
const Kyc = () => {
  const { fetchKyc, bookings } = useFetchContext();
  const { currentMode, currentColor } = useStateContext();
  const [pagination, setPagination] = useState({
    pageIndex: 0, // zero-based page index
    pageSize: 10,
  });
  const [kyc, setKyc] = useState([]);
  const [totalCount, setTotalCount] = useState(0);
  const navigate = useNavigate();

  useEffect(() => {
    if (pagination) {
      (async () => {
        const { data, totalCount } = await fetchKyc(
          pagination.pageIndex,
          pagination.pageSize
        );
        setKyc(data);
        setTotalCount(totalCount);
      })();
    }
  }, [pagination]);

  const columns = useMemo(() => [
    {
      accessorKey: "identityVerification.method",
      header: "Verification Method",
      size: 80,
    },
    {
      accessorKey: "user.email",
      header: "Email",
      size: 80,
    },
    {
      accessorFn: (row) =>
        row.status === "reviewing" ? (
          <span className="bg-orange-100 text-yellow-800 text-sm font-medium me-2 px-2.5 py-0.5 rounded-xl dark:bg-yellow-900 dark:text-yellow-300">
            Reviewing
          </span>
        ) : (
          <span className="bg-red-100 text-orange-800 text-sm font-medium me-2 px-2.5 py-0.5 rounded-xl dark:bg-orange-900 dark:text-orange-300">
            Suspended
          </span>
        ),
      accessorKey: "status",
      header: "Status",
      size: 80,
    },
  ]);
  return (
    <div className="m-2 md:m-10 p2 md:p-10 dark:bg-secondary-dark-bg bg-white rounded-3xl">
      <div className="flex w-full justify-between items-center">
        <Header title="KYC" />
      </div>
      {kyc?.length < 0 ? (
        <div className="min-h-[20rem] w-full items-center justify-center flex">
          <Loading
            color={currentMode === "Dark" ? "#20232A" : "#fafafa"}
            bgColor={currentMode === "Dark" ? "#fafafa" : "#20232A"}
          />
        </div>
      ) : (
        <div className="w-full grid">
          <Table
            data={kyc}
            pagination={pagination}
            onPaginationChange={(newPagination) => {
              setPagination(newPagination);
            }}
            totalCount={totalCount}
            renderRowActions={({ row, table }) => (
              <Box
                sx={{
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "center",
                }}
              >
                <Tooltip arrow placement="right" title="View Details">
                  <IconButton
                    onClick={() => {
                      navigate(`/kyc/${row.original._id}`);
                    }}
                  >
                    <Send className="dark:text-white-shade text-black-shade" />
                  </IconButton>
                </Tooltip>
              </Box>
            )}
            columns={columns}
          />
        </div>
      )}
    </div>
  );
};

export default Kyc;
